import React from 'react';
import Button from '../ui/Button';
import Card from '../ui/Card';

export default class ChallengeTicketRouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error('[ticket] page_failed', error?.message || String(error));
  }

  componentDidUpdate(prevProps) {
    if (this.props.resetKey !== prevProps.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen min-h-[100dvh] bg-[#0a0a0a] text-white flex items-center justify-center px-4">
          <Card variant="solid" padding="lg" className="max-w-md w-full text-center space-y-4">
            <p className="text-lg font-black">Ticket could not load.</p>
            <p className="text-sm text-gray-400 font-medium">
              This challenge ticket link hit an unexpected error. Try again or return home.
            </p>
            <div className="flex flex-col gap-2">
              <Button type="button" variant="brand" fullWidth onClick={() => window.location.reload()}>
                Retry
              </Button>
              <Button type="button" variant="secondary" fullWidth onClick={() => { window.location.href = '/'; }}>
                Go Home
              </Button>
            </div>
          </Card>
        </div>
      );
    }
    return this.props.children;
  }
}
